module.exports = __webpack_public_path__ + "img/bg-top.970ce1b9.png";